export default "__VITE_ASSET__Cxmf8sSZ__"